import usePageTitle from "../../../hooks/use-page-title";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import ROLE from '../../../modules/role';
import { useContext, useEffect } from "react";
import AppUserContext from "../../../context/app-user-context";
import PageProfile_Student from "./PageProfile_Student";
import PageProfile_Supervisor from "./PageProfile_Supervisor";
import PageProfile_PA from "./PageProfile_PA";
import PageProfile_Admin from "./PageProfile_Admin";

const TITLE = "My Profile";

export default function PageDashboard() {
  usePageTitle(TITLE);
  usePortalSettingSet("label_header", TITLE);
  const { setCustomText } = useContext(PortalContext);

  useEffect(() => {
    setCustomText(TITLE);
  }, []);

  const user = useContext(AppUserContext);

  return <main className="content-generic content-generic--fluid page-dashboard" data-comp="PageDashboard">

    {user.role === ROLE.ADMIN && <PageProfile_Admin />}

    {user.role === ROLE.PROGRAMME_ADMIN && <PageProfile_PA />}

    {user.role === ROLE.STUDENT && <PageProfile_Student />}

    {user.role === ROLE.SUPERVISOR && <PageProfile_Supervisor />}

    {user.role === ROLE.INDUSTRY_SUPERVISOR && <PageProfile_Supervisor />}

  </main>;
}
